import React, { useContext,useEffect,useState,useRef } from 'react'
import TimeTableContext from '../context/timeTableContext'
import { getHighestHour,getClassHoursById,changeDateFormat } from '../helpers/TimeTableHelpers'
import { splitChangesToGroup,getDailyChangesArray } from '../helpers/ChangesHelpers'
import ChangeBox from './parts/ChangeBox'
import Slider from './Slider'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft,faChevronRight } from '@fortawesome/free-solid-svg-icons'

const ChangesTable = () => {
  const [value, setValue] = useState(true)
  
  const currentUrl = new URL(window.location)
  const countClasses = currentUrl.searchParams.get('count') ? currentUrl.searchParams.get('count') : 5

  const context = useContext(TimeTableContext)
  let cssClasses
  let timeDictonary

  useEffect(() => {
    let id = setInterval(() => {
      setValue(!value)
    }, 900000000)
    return () => clearInterval(id)
  })

  

  const widthTd = Math.floor(100 / countClasses) + "%"

  let changes = getDailyChangesArray(context,parseInt(countClasses))
  //let changesGroup = splitChangesToGroup(changes,5,context.state.classes.length)
  //console.log(changes)

  let today = new Date()
  let dayName = context.state.daysOfTheWeek[context.state.daySelected]

  if(context.state.useSlotLabels){
    timeDictonary = getClassHoursById(context.state) 
  }

  let totalSlide = Math.round(parseInt(context.state.classes.length) / countClasses);

  return (
    <div>
    
    <h3 className="text-center">
    <button className="btn btn-info btn-move-day-back" onClick={(e) => {
      if(context.state.daySelected === 0)
        return

      context.dispatch({type:"SET_CURRENT_DAY",payload:context.state.daySelected - 1})
      context.dispatch({type:"SET_CURRENT_DATE",payload:context.state.dateSelected.subtract(1, "days")})
      }}><FontAwesomeIcon icon={faChevronRight} /></button>
       שינויים במערכת {dayName} {changeDateFormat(context.state.dateSelected)}
    <button className="btn btn-info btn-move-day-forward" onClick={(e) => {
      if(context.state.daySelected === 5)
        return

      context.dispatch({type:"SET_CURRENT_DAY",payload:context.state.daySelected + 1})
      context.dispatch({type:"SET_CURRENT_DATE",payload:context.state.dateSelected.add(1, "days")})
      }}><FontAwesomeIcon icon={faChevronLeft} /></button>
    </h3>
    
    <Slider className="container-fluid slider" context={context} totalSlide={totalSlide} style={{clear:"both"}}>
    
    {
      changes.map((changeTop,key) => {
        cssClasses = key === 1 ? "slide slide_visible" : "slide"
        return(
          <div className={cssClasses}>
          <table className="table-changes table table-bordered table-responsive">
          <thead className="thead-dark">
          <tr>
          <th style={{width:"2%"}}></th>
          {
            changeTop[0].map((changeGroup,key) => {
              return(
                <th style={{width:widthTd,textAlign:"center",fontSize:"18px",fontWeight:"bold"}}>{context.state.classes[key].name}</th>
              )
            })
          }
          </tr>
          </thead>
          {
            
            changeTop.map((changeGroup,key) => {
              
              let hourInTable = timeDictonary ? timeDictonary[key].start : (key + context.state.firstHour)
              
              return( 
                <tr>
                <td>{hourInTable}</td>
                {
                  changeGroup.map((change,key) => {
                    return(
                    <td className="box-changes" >
                      {
                          change.map((changeInner) => {
                              //console.log(changeInner)
                              return(
                                <React.Fragment>
                                {
                                    
                                    changeInner.map(changeInnerBox => {
                                      return(
                                        <ChangeBox change={changeInnerBox} clean={true}/>
                                      )
                                    })
                                
                              }
                              
                              </React.Fragment>
                              )



                          })
                      }
                    </td>
                    )
                  })
                }
                </tr>
              )
              
            })
          }  
          </table>
          </div>
        )
      })
    }
    
    </Slider>
    </div>
  )
}

export default ChangesTable
